import React, { useState, useRef } from "react";
import { adminAircraftSearch, adminAircraftOperators } from "../../lib/api";
import { Picture } from "../../lib/icons";

export default function AircraftLookup() {
  const [q, setQ] = useState("");
  const [sugs, setSugs] = useState([]);
  const [open, setOpen] = useState(false);
  const [sel, setSel] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const timer = useRef(null);

  const onType = (v) => {
    setQ(v); setOpen(true);
    clearTimeout(timer.current);
    if (!v.trim()) { setSugs([]); return; }
    timer.current = setTimeout(async () => {
      try { setSugs(await adminAircraftSearch(v)); } catch { setSugs([]); }
    }, 180);
  };

  const pick = async (a) => {
    setSel(a); setQ(a.name); setOpen(false); setLoading(true); setResult(null);
    try { setResult(await adminAircraftOperators(a.code)); } catch { setResult(null); }
    setLoading(false);
  };

  return (
    <div className="panel">
      <h3>Aircraft lookup</h3>
      <p className="adm-sub" style={{ marginTop: -8 }}>Type an aircraft name (or the start of it) to find its full name and every operator that flies it.</p>

      <div style={{ position: "relative", maxWidth: 520 }}>
        <input
          className="lookup-input"
          placeholder="e.g. King, Legacy, Bell, Embraer…"
          value={q}
          onChange={(e) => onType(e.target.value)}
          onFocus={() => q && setOpen(true)}
          autoComplete="off"
        />
        {open && sugs.length ? (
          <div className="lookup-drop">
            {sugs.map((a) => (
              <button key={a.code} type="button" className="lookup-item" onClick={() => pick(a)}>
                <div className="lookup-thumb"><Picture code={a.code} /></div>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 700 }}>{a.name}</div>
                  <div style={{ color: "var(--muted)", fontSize: 12.5 }}>{a.cls_name} · {a.fleet_count} in India's fleet</div>
                </div>
              </button>
            ))}
          </div>
        ) : null}
        {open && q && !sugs.length ? <div className="lookup-drop"><div style={{ padding: 12, color: "var(--muted)" }}>No aircraft match “{q}”.</div></div> : null}
      </div>

      {loading ? <p className="adm-sub" style={{ marginTop: 16 }}>Loading operators…</p> : null}

      {result ? (
        <div style={{ marginTop: 18 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 14 }}>
            <div style={{ width: 74, height: 56, borderRadius: 10, overflow: "hidden", position: "relative", flex: "none" }}><Picture code={result.code} /></div>
            <div>
              <div style={{ fontFamily: "var(--display)", fontWeight: 500, fontSize: 22 }}>{result.name}</div>
              <div style={{ color: "var(--muted)", fontSize: 14 }}>{result.cls_name}</div>
            </div>
          </div>
          <div className="cards" style={{ marginBottom: 18 }}>
            <div className="kpi"><div className="v">{result.operator_count}</div><div className="l">Operators with this type</div></div>
            <div className="kpi"><div className="v">{result.tail_count}</div><div className="l">Aircraft (tails) in India</div></div>
          </div>
          {result.operator_count ? (
            <table className="tbl">
              <thead><tr><th>Operator</th><th>City</th><th>Registrations</th><th>Contact</th></tr></thead>
              <tbody>
                {result.operators.map((o) => (
                  <tr key={o.id} style={{ cursor: "default" }}>
                    <td style={{ fontWeight: 700 }}>{o.name}<div style={{ color: "var(--muted)", fontSize: 12, fontWeight: 400 }}>AOP {o.aop} · valid {o.valid}</div></td>
                    <td>{o.city || "—"}</td>
                    <td>{o.tails.map((t, i) => <span key={i} className="pill Quoted" style={{ marginRight: 6, marginBottom: 4, display: "inline-block" }}>{t.reg || "—"} · {t.seats} seats</span>)}</td>
                    <td style={{ fontSize: 13 }}>{o.phone || "—"}{o.emails?.length ? <div style={{ color: "var(--muted)" }}>{o.emails[0]}</div> : null}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : <p className="adm-sub">No operators currently list this aircraft type.</p>}
        </div>
      ) : null}
    </div>
  );
}
